module.exports = __webpack_public_path__ + "static/media/sfWidget.218f6f2e.png";